import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

export const POLICY_UPDATED = "October 16, 2026";
export const POLICY_EMAIL = "phase@slayfulpawsco.cloud";
export const POLICY_ADDRESS = "390 Lofton Rd NW, Atlanta, GA 30309 US";

export function PolicyEmail({ subject }) {
  const href = subject
    ? `mailto:${POLICY_EMAIL}?subject=${encodeURIComponent(subject)}`
    : `mailto:${POLICY_EMAIL}`;

  return <a href={href}>{POLICY_EMAIL}</a>;
}

function PolicyPage({ title, intro, children, showDirectoryLink = true }) {
  return (
    <main id="main" className="main">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <p className="policy-kicker">slayfulpawsco policies</p>
          <h1>{title}</h1>
          <p className="policy-updated">Last updated: {POLICY_UPDATED}</p>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            {intro && <p className="policy-intro">{intro}</p>}
            {children}
            {showDirectoryLink && (
              <p className="policy-directory-link">
                <Link to="/policies">View all store policies</Link>
              </p>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}

export default PolicyPage;
